import axios from 'axios'
import constants from '../lib/constants'

// CONSTANTS
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS'
export const GET_ORGANIZATIONS_COMPLETE = 'GET_ORGANIZATIONS_COMPLETE'
export const CREATE_ORGANIZATION = 'CREATE_ORGANIZATION'
export const CREATE_ORGANIZATION_COMPLETE = 'CREATE_ORGANIZATION_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getOrganizations = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_ORGANIZATIONS })
    return axios.get(`${constants.API_URL}/organizations/list`)
    .then((response) => {
      const sortedOrganizations = response.data.organizations.sort((a, b) => (a.name > b.name ? 1 : -1))
      dispatch({
        type    : GET_ORGANIZATIONS_COMPLETE,
        payload : {
          organizations: sortedOrganizations,
        }
      })
      return response
    })
  }
}

export const createOrganization = (name) => {
  return (dispatch) => {
    dispatch({ type: CREATE_ORGANIZATION })
    return axios.post(`${constants.API_URL}/organizations/create`,
      {
        name
      }
    )
    .then((response) => {
      const newOrganization = response.data
      dispatch({
        type    : CREATE_ORGANIZATION_COMPLETE,
        payload : {
          createdOrganization: newOrganization
        }
      })
      return response
    })
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_ORGANIZATIONS_COMPLETE] : (state, action) => {
    const { organizations } = action.payload
    const newState = {
      ...state,
      organizations
    }
    return newState
  },
  [CREATE_ORGANIZATION_COMPLETE] : (state, action) => {
    const { createdOrganization } = action.payload
    const newState = {
      ...state,
      createdOrganization
    }
    return newState
  }
}

// REDUCER

const initialState = {
  organizations: [],
  createdOrganization: null,
}

export default function organizationsReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/organizations.js